import { tr } from 'mmfintech-commons'
import { useCryptoCurrencyNotes } from 'mmfintech-checkout-commons'

import { WarningMessageTitle, WarningMessageWrapper } from './WarningMessage.styled'

import type { CryptoNotesDetails } from 'mmfintech-checkout-commons/types'

import InfoIcon from '../../assets/icons/info-circle.svg'

export const WarningMessage = ({ currency }) => {
  const notes = useCryptoCurrencyNotes(currency, true)

  if (notes) {
    return (
      <WarningMessageWrapper>
        <WarningMessageTitle>
          <img src={InfoIcon} alt='' />
          <span>{tr('CHECKOUT.WARNING_MESSAGE.PLEASE_NOTE', 'Please note')}</span>
        </WarningMessageTitle>

        {notes.map((line: CryptoNotesDetails) => (
          <p key={line.keyName}>{line.keyName ? tr(line.keyName, line.defaultValue) : line.defaultValue}</p>
        ))}
      </WarningMessageWrapper>
    )
  }

  return null
}
